import { c as _c } from "react/compiler-runtime";
export default function ChevronRight(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.97 28a1 1 0 01-.55-1.835c4.059-2.665 8.045-6.101 11.528-9.934a.36.36 0 00-.001-.462c-3.483-3.833-7.47-7.268-11.526-9.933a1 1 0 111.098-1.672c4.196 2.756 8.313 6.303 11.909 10.259.804.884.804 2.269 0 3.152-3.594 3.956-7.712 7.504-11.91 10.26a.987.987 0 01-.431.159L11.97 28z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}